import React from 'react';

class Footer extends React.Component {
	render() {
		return (
            <div className='footer'>
                <center>
                    <span className='icon-telephone'><a href="tel:+4570201297">+45 7020 1297</a></span>
					<span className='icon-email'><a href="mailto:info@directhedge.com">info@directhedge.com</a></span><br/>
                    Regulated by the Danish Financial Supervisory Authority
                </center>
                <div className='version'>{ __VERSION__ }</div>
            </div>
		)
	}
}

export default Footer;



// WEBPACK FOOTER //
// ./source/components/footer.js